import { sb } from '../supabase.ts';
import { escapeHtml } from '../main.ts';

export async function renderDataPrintPage(app: HTMLElement) {
  const tableName = 'student_database';
  
  const allCols = [
    { id: 'session', label: 'session' },
    { id: 'student_name_en', label: 'student_name_en' },
    { id: 'student_name_bn', label: 'student_name_bn' },
    { id: 'birth_registration', label: 'birth_registration' },
    { id: 'student_dateofbirth', label: 'student_dateofbirth' },
    { id: 'student_gender', label: 'student_gender' },
    { id: 'religion', label: 'religion' },
    { id: 'student_blood_group', label: 'student_blood_group' },
    { id: 'active_class', label: 'active_class' },
    { id: 'active_section', label: 'active_section' },
    { id: 'active_roll', label: 'active_roll' },
    { id: 'class_2026', label: 'class_2026' },
    { id: 'section_2026', label: 'section_2026' },
    { id: 'roll_2026', label: 'roll_2026' },
    { id: 'class_2025', label: 'class_2025' },
    { id: 'section_2025', label: 'section_2025' },
    { id: 'roll_2025', label: 'roll_2025' },
    { id: 'class_2024', label: 'class_2024' },
    { id: 'section_2024', label: 'section_2024' },
    { id: 'roll_2024', label: 'roll_2024' },
    { id: 'father_name_en', label: 'father_name_en' },
    { id: 'father_name_bn', label: 'father_name_bn' },
    { id: 'father_nid', label: 'father_nid' },
    { id: 'father_mobile', label: 'father_mobile' },
    { id: 'father_occupation', label: 'father_occupation' },
    { id: 'father_dob', label: 'father_dob' },
    { id: 'father_blood_group', label: 'father_blood_group' },
    { id: 'mother_name_en', label: 'mother_name_en' },
    { id: 'mother_name_bn', label: 'mother_name_bn' },
    { id: 'mother_nid', label: 'mother_nid' },
    { id: 'mother_mobile', label: 'mother_mobile' },
    { id: 'mother_occupation', label: 'mother_occupation' },
    { id: 'mother_dob', label: 'mother_dob' },
    { id: 'mother_blood_group', label: 'mother_blood_group' },
    { id: 'guardian_name_en', label: 'guardian_name_en' },
    { id: 'guardian_name_bn', label: 'guardian_name_bn' },
    { id: 'guardian_nid', label: 'guardian_nid' },
    { id: 'guardian_mobile', label: 'guardian_mobile' },
    { id: 'guardian_occupation', label: 'guardian_occupation' },
    { id: 'board_name', label: 'board_name' },
    { id: 'board_roll', label: 'board_roll' },
    { id: 'board_registration', label: 'board_registration' },
    { id: 'group', label: 'group' },
    { id: 'optional_subject', label: 'optional_subject' },
    { id: 'village_en', label: 'village_en' },
    { id: 'village_bn', label: 'village_bn' },
    { id: 'postoffice_en', label: 'postoffice_en' },
    { id: 'postoffice_bn', label: 'postoffice_bn' },
    { id: 'union_en', label: 'union_en' },
    { id: 'union_bn', label: 'union_bn' },
    { id: 'upazilla_en', label: 'upazilla_en' },
    { id: 'upazilla_bn', label: 'upazilla_bn' },
    { id: 'district_en', label: 'district_en' },
    { id: 'district_bn', label: 'district_bn' },
    { id: 'previous_school', label: 'previous_school' },
    { id: 'comment_school', label: 'comment_school' },
    { id: 'admission_date', label: 'admission_date' },
    { id: 'previous_class_roll', label: 'previous_class_roll' },
    { id: 'school_reg_sl', label: 'school_reg_sl' },
    { id: 'quote_freedomfighter', label: 'quote_freedomfighter' },
    { id: 'status', label: 'status' },
    { id: 'tc_date', label: 'tc_date' },
    { id: 'tc_no', label: 'tc_no' },
    { id: 'rfid_card_no', label: 'rfid_card_no' },
    { id: 'fulldata_ok', label: 'fulldata_ok' },
    { id: 'student_key', label: 'student_key' },
    { id: 'student_photo_url', label: 'student_photo_url' },
    { id: 'birth_certificate_url', label: 'birth_certificate_url' },
    { id: 'registration_card_url', label: 'registration_card_url' }
  ];

  app.innerHTML = `
    <style>
      :root {
        --bg: #f0f4f9;
        --card-bg: #ffffff;
        --primary: #6366f1;
        --accent: #4f46e5;
        --text: #1e293b;
        --text-muted: #64748b;
        --radius: 20px;
        --shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.05);
      }

      .print-container { 
        font-family: 'Outfit', sans-serif; 
        padding: 20px 15px; 
        background: var(--bg); 
        min-height: 100vh; 
        color: var(--text);
      }
      
      .no-print { 
        width: 100%;
        margin: 0 0 15px;
      }

      .header-section {
        background: white;
        padding: 20px;
        border-radius: var(--radius);
        box-shadow: var(--shadow);
        margin-bottom: 15px;
        text-align: center;
        border: 1px solid rgba(255, 255, 255, 0.7);
      }

      .school-title {
        font-size: 24px;
        font-weight: 800;
        background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin-bottom: 4px;
        letter-spacing: -0.5px;
        text-transform: uppercase;
      }

      .header-section p {
        color: var(--text-muted);
        font-size: 13px;
        font-weight: 500;
      }

      .control-center {
        background: white;
        padding: 15px 20px;
        border-radius: var(--radius);
        box-shadow: var(--shadow);
        margin-bottom: 15px;
      }

      .filter-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
        gap: 15px;
        margin-bottom: 15px;
      }

      .input-field {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }

      .input-field label {
        font-size: 13px;
        font-weight: 700;
        color: var(--text-muted);
        text-transform: uppercase;
        letter-spacing: 0.5px;
        margin-left: 5px;
      }

      .input-field select {
        padding: 10px 14px;
        border-radius: 10px;
        border: 1px solid #e2e8f0;
        background: #f8fafc;
        font-size: 13px;
        font-weight: 600;
        color: var(--text);
        outline: none;
        cursor: pointer;
        transition: all 0.2s;
      }

      .input-field select:focus {
        border-color: var(--primary);
        box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.1);
      }

      .btn-container {
        display: flex;
        justify-content: center;
        gap: 10px;
        padding-top: 15px;
        border-top: 1px solid #f1f5f9;
      }
      
      .btn-action {
        padding: 10px 18px;
        border-radius: 10px;
        border: none;
        font-size: 13px;
        font-weight: 700;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .btn-action.secondary {
        background: #f1f5f9;
        color: #475569;
      }

      .btn-action.secondary:hover {
        background: #e2e8f0;
      }

      .btn-action.primary {
        background: var(--primary);
        color: white;
        box-shadow: 0 10px 20px rgba(99, 102, 241, 0.2);
      }

      .btn-action.primary:hover {
        background: var(--accent);
        transform: translateY(-2px);
        box-shadow: 0 15px 30px rgba(99, 102, 241, 0.3);
      }

      .column-picker {
        background: white;
        padding: 15px 20px;
        border-radius: var(--radius);
        box-shadow: var(--shadow);
      }

      .section-title {
        font-size: 14px;
        font-weight: 700;
        margin-bottom: 12px;
        color: var(--text);
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .section-title::before {
        content: '';
        width: 4px;
        height: 18px;
        background: var(--primary);
        border-radius: 2px;
      }

      .col-grid { 
        display: flex; 
        flex-wrap: wrap; 
        gap: 6px; 
        align-items: center;
      }

      .col-item { 
        display: flex; 
        align-items: center; 
        gap: 4px; 
        font-size: 11px; 
        padding: 4px 8px; 
        background: white;
        border: 1px solid #e2e8f0;
        border-radius: 6px;
        transition: all 0.2s;
        cursor: pointer;
      }

      .col-item:hover {
        border-color: var(--primary);
        background: #f8fafc;
      }

      .col-item input {
        width: 14px;
        height: 14px;
        margin: 0;
        cursor: pointer;
      }

      .col-item label {
        cursor: pointer;
        font-weight: 500;
        color: #475569;
      }
      
      .status-pill {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        background: #f1f5f9;
        padding: 6px 12px;
        border-radius: 99px;
        font-size: 12px;
        font-weight: 700;
        color: var(--primary);
      }

      /* Table Styles */
      .table-wrapper {
        background: white;
        border-radius: var(--radius);
        box-shadow: var(--shadow);
        overflow: hidden;
        margin-top: 30px;
      }

      table { 
        width: 100%; 
        border-collapse: collapse; 
        font-size: 13px; 
      }
      
      th { 
        background: #f8fafc; 
        padding: 12px 10px; 
        text-align: center; 
        color: var(--text-muted);
        font-weight: 700;
        text-transform: uppercase;
        font-size: 11px;
        letter-spacing: 0.5px;
        border: 1px solid #e2e8f0;
      }

      td { 
        padding: 10px; 
        text-align: center; 
        border: 1px solid #e2e8f0;
        color: var(--text);
      }

      tr:nth-child(even) {
        background: #fafbfc;
      }

      tr:hover {
        background: #f5f7ff;
      }
      
      @media print {
        .no-print { display: none !important; }
        .print-container { padding: 0.5cm; background: white; }
        .table-wrapper { box-shadow: none; border-radius: 0; }
        table { width: 100%; border: 1px solid #000; border-collapse: collapse; }
        th, td { border: 1px solid #000; color: #000; padding: 4px; font-size: 10px; }
        th { background: #eee !important; -webkit-print-color-adjust: exact; }
        @page { margin: 1cm; }
      }
    </style>

    <div class="print-container">
      <div class="no-print">
        <div class="header-section">
          <h1 class="school-title">FENI MODEL HIGH SCHOOL</h1>
          <p>Student Data Management & Printing System</p>
        </div>
        
        <div class="control-center">
          <div class="filter-grid">
            <div class="input-field">
              <label>Academic Session</label>
              <select id="sessionSelect"></select>
            </div>
            <div class="input-field">
              <label>Select Class</label>
              <select id="classSelect"></select>
            </div>
            <div class="input-field">
              <label>Section (Optional)</label>
              <select id="sectionSelect"></select>
            </div>
          </div>

          <div class="btn-container">
            <div id="status" class="status-pill"></div>
            <div style="flex:1"></div>
            <button id="selectAll" class="btn-action secondary">Select All Columns</button>
            <button id="clearAll" class="btn-action secondary">Clear All</button>
            <button onclick="window.print()" class="btn-action primary">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 6 2 18 2 18 9"></polyline><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><rect x="6" y="14" width="12" height="8"></rect></svg>
              Print Page
            </button>
          </div>
        </div>
        
        <div class="column-picker">
          <div class="section-title">Column Configuration</div>
          <div class="col-grid" id="colGrid"></div>
        </div>
      </div>

      <div id="printArea" class="table-wrapper">
        <table id="mainPrintTable">
          <thead>
            <tr class="school-row">
              <th id="schoolHeaderCell" colspan="100" style="background:#fff !important; border:none; padding-bottom:20px;">
                <h1 style="margin:0; font-size:24px; color:#000;">FENI MODEL HIGH SCHOOL</h1>
                <p id="printSub" style="margin:5px 0 0; font-size:14px; font-weight:normal; color:#333;"></p>
              </th>
            </tr>
            <tr id="theadRow"></tr>
          </thead>
          <tbody id="tbody"></tbody>
          <tfoot style="display: table-footer-group;">
            <tr>
              <td id="footerCell" colspan="100" style="border:none; text-align:right; padding-top:10px; font-size:10px; color:#666;">
                <div class="page-footer"></div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  `;

  const colGrid = document.getElementById('colGrid')!;
  const sessionSelect = document.getElementById('sessionSelect') as HTMLSelectElement;
  const classSelect = document.getElementById('classSelect') as HTMLSelectElement;
  const sectionSelect = document.getElementById('sectionSelect') as HTMLSelectElement;
  const theadRow = document.getElementById('theadRow')!;
  const tbody = document.getElementById('tbody')!;
  const printSub = document.getElementById('printSub')!;
  const status = document.getElementById('status')!;

  const savedSes = localStorage.getItem('print_ses') || '2026';
  const savedCls = localStorage.getItem('print_cls') || '';
  const savedSec = localStorage.getItem('print_sec') || '';
  const savedCols = localStorage.getItem('print_cols');

  let selectedCols: string[] = savedCols ? JSON.parse(savedCols) : ['session', 'student_name_en', 'class_2025', 'section_2025', 'roll_2025'];
  let currentRows: any[] = [];

  function saveSettings() {
    localStorage.setItem('print_ses', sessionSelect.value);
    localStorage.setItem('print_cls', classSelect.value);
    localStorage.setItem('print_sec', sectionSelect.value);
    localStorage.setItem('print_cols', JSON.stringify(selectedCols));
  }

  function renderCheckboxes() {
    colGrid.innerHTML = allCols.map(c => `
      <div class="col-item">
        <input type="checkbox" id="p-${c.id}" data-id="${c.id}" ${selectedCols.includes(c.id) ? 'checked' : ''}>
        <label for="p-${c.id}">${c.label}</label>
      </div>
    `).join('');

    colGrid.querySelectorAll('input').forEach(chk => {
      chk.onchange = (e: any) => {
        const id = e.target.dataset.id;
        if (e.target.checked) {
          if (!selectedCols.includes(id)) selectedCols.push(id);
        } else {
          selectedCols = selectedCols.filter(x => x !== id);
        }
        fetchData();
        saveSettings();
      };
    });
  }

  // Init Filters
  sessionSelect.innerHTML = ['2022','2023','2024','2025','2026','2027','2028'].map(s => `<option value="${s}" ${s===savedSes?'selected':''}>${s}</option>`).join('');

  async function loadClasses(targetCls?: string) {
    const ses = sessionSelect.value;
    const { data } = await sb.from(tableName).select(`class_${ses}`).not(`class_${ses}`, 'is', null);
    const set = new Set<string>();
    (data||[]).forEach((r: any) => set.add(String(r[`class_${ses}`])));
    classSelect.innerHTML = '<option value="">Select Class</option>' + Array.from(set).sort().map(c => `<option value="${c}" ${c===targetCls?'selected':''}>${c}</option>`).join('');
  }

  async function loadSections(targetSec?: string) {
    const ses = sessionSelect.value;
    const cls = classSelect.value;
    const { data } = await sb.from(tableName).select(`section_${ses}`).eq(`class_${ses}`, cls).not(`section_${ses}`, 'is', null);
    const set = new Set<string>();
    (data||[]).forEach((r: any) => set.add(String(r[`section_${ses}`])));
    sectionSelect.innerHTML = '<option value="">All Sections</option>' + Array.from(set).sort().map(s => `<option value="${s}" ${s===targetSec?'selected':''}>${s}</option>`).join('');
  }

  async function fetchData() {
    const ses = sessionSelect.value;
    const cls = classSelect.value;
    const sec = sectionSelect.value;
    if (!ses || !cls) { tbody.innerHTML = ''; return; }

    status.textContent = 'Loading...';
    printSub.textContent = `Session: ${ses}, Class: ${cls}${sec ? `, Section: ${sec}` : ''}`;
    
    let query = sb.from(tableName).select('iid,student_name_en,' + selectedCols.join(',')).eq(`class_${ses}`, cls);
    if (sec) query = query.eq(`section_${ses}`, sec);

    const { data, error } = await query.order(`roll_${ses}`, { ascending: true }).limit(2000);
    if (error) { status.textContent = 'Error'; return; }
    
    currentRows = data || [];
    status.textContent = `Total: ${currentRows.length}`;
    
    // Update colspan for header and footer cells
    const totalCols = 2 + selectedCols.length;
    const schoolHeaderCell = document.getElementById('schoolHeaderCell')!;
    const footerCell = document.getElementById('footerCell')!;
    schoolHeaderCell.setAttribute('colspan', totalCols.toString());
    footerCell.setAttribute('colspan', totalCols.toString());

    refreshTable();
  }

  function refreshTable() {
    theadRow.innerHTML = '<th>SL</th><th>iid</th>' + selectedCols.map(c => `<th>${c}</th>`).join('');
    tbody.innerHTML = currentRows.map((r, idx) => `
      <tr>
        <td>${idx+1}</td>
        <td>${r.iid}</td>
        ${selectedCols.map(c => {
          let val = (r[c] === null || r[c] === undefined) ? '' : String(r[c]);
          if (val && (c.includes('date') || c.includes('dob'))) {
            const s = val.trim();
            if (s.includes('T')) {
              val = s.split('T')[0];
            } else {
              const parts = s.split(/[-/]/);
              if (parts.length === 3) {
                if (parts[0].length === 4) {
                  val = `${parts[2].padStart(2, '0')}/${parts[1].padStart(2, '0')}/${parts[0]}`;
                } else if (parts[2].length === 4) {
                  val = `${parts[0].padStart(2, '0')}/${parts[1].padStart(2, '0')}/${parts[2]}`;
                }
              }
            }
          }
          return `<td>${escapeHtml(val)}</td>`;
        }).join('')}
      </tr>
    `).join('');
  }

  sessionSelect.onchange = () => { loadClasses(); fetchData(); saveSettings(); };
  classSelect.onchange = () => { loadSections(); fetchData(); saveSettings(); };
  sectionSelect.onchange = () => { fetchData(); saveSettings(); };

  document.getElementById('selectAll')!.onclick = () => { selectedCols = allCols.map(c=>c.id); renderCheckboxes(); refreshTable(); saveSettings(); };
  document.getElementById('clearAll')!.onclick = () => { selectedCols = []; renderCheckboxes(); refreshTable(); saveSettings(); };

  renderCheckboxes();
  if (savedSes) {
    await loadClasses(savedCls);
    if (savedCls) {
      await loadSections(savedSec);
      fetchData();
    }
  } else {
    await loadClasses();
  }
}
